import {FC} from "react";
import Typography from "@mui/material/Typography";
import {alpha, Link, Stack} from "@mui/material";
import Grid from "@mui/material/Grid";
import {useTheme} from "@mui/material/styles";
import {Link as RouterLink} from "react-router-dom";

interface IFooterLinks {
    title: string,
    links: { label: string, path: string }[]
}

interface IProps {
    footerLinks: IFooterLinks
}

const FooterLinks: FC<IProps> = (props) => {
    const theme = useTheme()

    const linkStyles = {
        fontSize: {xs: '0.875rem', md: "1rem"},
        textDecoration: 'none',
        color: alpha(theme.palette.primary.main, .7),
        transition: 'color .2s ease',
        '&:hover': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
            cursor: 'pointer'
        },
    }

    return (
        <Grid
            sx={{display: "flex", justifyContent: {xs: "center", md: "flex-start"}}}
            size={{
                xs: 4,
                sm: 4,
                md: "auto"
            }}>
            <Stack alignItems="flex-start">
                <Typography variant='button' color="primary" fontWeight='bold'
                            sx={{display: "block", mb: 0.65, textAlign: "left"}}>
                    {props.footerLinks.title}
                </Typography>
                <Stack alignItems="flex-start">
                    {props.footerLinks.links.map((l) => (
                        !l.path.includes('http') ?
                            <Link key={l.path} component={RouterLink} to={l.path} sx={linkStyles}>{l.label}</Link> :
                            <Link key={l.path} href={l.path} sx={linkStyles} target="_blank"
                                  rel="noopener noreferrer">{l.label}</Link>
                    ))}
                </Stack>
            </Stack>
        </Grid>
    );
}

export default FooterLinks
